export const GENDER = "GENDER";

export const AGE = "AGE";

export const WEIGHT = "WEIGHT";

export const HEIGHT = "HEIGHT";

export const ACTIVITY = "ACTIVITY";

export const PROTEIN = "PROTEIN";

export const CARBS = "CARBS";

export const FAT = "FAT";

export const CALORIES = "CALORIES";

export const GOAL = "GOAL";

export const GOALCALORIES = "GOALCALORIES";

export const MEAL = "MEAL";

export const INFOSUBMIT = "INFOSUBMIT";

export const UNLOCK = "UNLOCK";
